interface BackArrowComponentProps {
  primaryColor?: string;
  secondaryColor?: string;
  onClick?: (value: any) => void;
  style?: React.CSSProperties;

}

const BackArrowSVGComponent = ({ primaryColor, secondaryColor, onClick, style }: BackArrowComponentProps) => (

<svg xmlns="http://www.w3.org/2000/svg" width="10" height="20" viewBox="0 0 10 20" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.78493 10L8.67743 15.8925L7.49909 17.0709L1.01743 10.5892C0.8612 10.4329 0.773438 10.221 0.773438 10C0.773437 9.77906 0.8612 9.56714 1.01743 9.41087L7.49909 2.9292L8.67743 4.10753L2.78493 10Z" fill="currentColor"/>
</svg>

);

export default BackArrowSVGComponent;
